import { render, staticRenderFns } from "./FormScreen.vue?vue&type=template&id=3afbd890&scoped=true&"
import script from "./FormScreen.vue?vue&type=script&lang=js&"
export * from "./FormScreen.vue?vue&type=script&lang=js&"
import style0 from "./FormScreen.vue?vue&type=style&index=0&id=3afbd890&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afbd890",
  null
  
)

export default component.exports